<page-header title="BUSINESS_LIST_BOOK"></page-header>
<card>
  <button
    class="button is-info"
    [disabled]="isLoading"
    [ngClass]="{ 'is-loading': isLoading }"
    (click)="createReport()"
    translationEditableDirective="GENERATE_REPORT"
  >
    {{ 'GENERATE_REPORT' | translate }}
  </button>
</card>
